/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DocumentConversion,
  DocumentConversionInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create document conversion
 */
export const createDocumentConversion = (
    documentConversionInput: MaybeRefOrGetter<DocumentConversionInput>,
 signal?: AbortSignal
) => {
      documentConversionInput = toValue(documentConversionInput);

      return axiosClient<DocumentConversion>(
      {url: `/document_conversions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentConversionInput, signal
    },
      );
    }




export const getCreateDocumentConversionMutationKey = () => ['createDocumentConversion'] as const;

export const getCreateDocumentConversionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentConversion>>, TError,CreateDocumentConversionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentConversion>>, TError,CreateDocumentConversionMutationVariables, TContext> => {

const mutationKey = getCreateDocumentConversionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentConversion>>, CreateDocumentConversionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createDocumentConversion(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentConversionMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentConversion>>>
    export type CreateDocumentConversionMutationBody = DocumentConversionInput
    export type CreateDocumentConversionMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateDocumentConversionMutationVariables = {data: DocumentConversionInput}

    /**
 * @summary Create document conversion
 */
export const useCreateDocumentConversion = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentConversion>>, TError,CreateDocumentConversionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createDocumentConversion>>,
        TError,
        CreateDocumentConversionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDocumentConversionMutationOptions(options), queryClient);
    }
